import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Link, Switch, Route, useLocation, useRouteMatch, useHistory } from 'react-router-dom';
import ProviderPracticeGrid from '../components/provider-dashboard/provider-practice-grid';
import AboutUser from '../components/provider-dashboard/about-user';
import { reloadData } from '../actions';
import { DRAWER_BREAK_POINT } from '../utils';
import { gray, blue, theme } from '../theme';
import RevenueCycleManagement from '../components/revenue-cycle-management';
import ProfileAccessManager from '../components/profile-access-manager';
import ProviderFacilitiesGrid from '../components/provider-facilities-grid';

const DRAWER_WIDTH = window.innerWidth <= DRAWER_BREAK_POINT ? window.innerWidth : 320;

const ProviderCompanies = (props) => {
  return (
    <h1>Provider Companies</h1>
  );
};

const Placeholder = props => <h1>{props.text}</h1>;

const UserProfile = (props) => {
  const [isDrawerOpen, toggleDrawer] = useState(true);
  const [isMobileLayout, setMobileLayout] = useState(false);

  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const { path } = useRouteMatch();

  const {
    drawerBackground,
    drawerBorderColor,
    drawerTextColor,
    drawerFontSize,
    drawerFontWeight,
    // Drawer Tabs
    tabBackground,
    tabActiveBackground,
    tabHoverBackground,
    tabIndicatorBackground,
    tabIndicatorHoverBackground,
    tabIndicatorActiveBackground,
    tabTextColor,
    tabHoverTextColor,
    tabActiveTextColor,
    groupHeaderTextColor,
    groupHeaderTextOpacity,
    groupHeaderFontSize,
    groupHeaderFontWeight
    // groupTabIndent
    // tabFontSize,
    // tabFontWeight,
    // groupSeparators,
    // headerBackground,
    // headerTextColor,
    // headerFontSize,
    // headerFontWeight
  } = theme.splitPanelDrawer;

  const styles = StyleSheet.create({
    container: {
      // marginTop: '40px'
      marginTop: '0px'
    },
    splitPanel: {
      display: 'flex',
      flexFlow: 'row nowrap',
      position: 'relative',
      background: gray[800],
      height: 'calc(100vh - 45px)',
      width: '100%',
      overflow: 'hidden',
      fontFamily: 'Lato'
    },
    drawer: {
      position: 'relative',
      height: '100%',
      transition: '0.3s',
      padding: '0',
      overflowY: 'auto',
      zIndex: '1900',
      borderRight: `1px solid ${drawerBorderColor}`,
      background: drawerBackground,
      color: drawerTextColor,
      fontSize: drawerFontSize,
      fontWeight: drawerFontWeight
    },
    openDrawer: {
      left: '0',
      minWidth: `${DRAWER_WIDTH}px`,
      width: `${DRAWER_WIDTH}px`
    },
    hideDrawer: {
      transition: '0.3s',
      width: '0px',
      minWidth: '0px',
      left: `calc(-1 * ${DRAWER_WIDTH}px)`
    },
    drawerHeader: {
      height: '40px',
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      // marginLeft: '8px',
      cursor: 'pointer',
      background: tabBackground,
      color: tabTextColor,
      borderBottom: `0.5px solid ${gray[700]}`,
      ':hover:not(.activeitem)': {
        background: tabHoverBackground,
        color: tabHoverTextColor
      }
    },
    drawerHeaderActive: {
      color: tabActiveTextColor,
      background: tabActiveBackground
    },
    drawerHeaderIconContainer: {
      color: '#0080FF',
      height: '32px',
      width: '32px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 4px',
      cursor: 'pointer'
    },
    drawerHeaderIcon: {
      fontSize: '24px',
      color: 'white',
      cursor: 'pointer'
    },
    drawerHeaderTextContainer: {
      textAlign: 'left',
      lineHeight: '14px',
      cursor: 'pointer'
    },
    drawerHeaderText: {
      textAlign: 'center',
      fontSize: '14px',
      // color: gray[300],
      cursor: 'pointer'
    },
    drawerHeaderTextSub: {
      // color: gray[300],
      fontSize: '14px',
      cursor: 'pointer'
    },
    drawerTabsContainer: {
      height: 'calc(100% - 64px)',
      overflowY: 'auto'
    },
    drawerAccordian: {
      position: 'relative',
      display: 'block',
      transition: '0.5s ease',
      maxHeight: '2000px'
    },
    detail: {
      position: 'relative',
      transition: '0.3s',
      height: '100%'
    },
    detailHeader: {
      height: '40px',
      background: '#001824',
      display: 'flex',
      alignItems: 'center',
      // justifyContent: 'space-between',
      borderBottom: '0.5px solid #082840',
      padding: '0 8px'
    },
    profileBanner: {
      borderBottom: '1px solid transparent'
    },
    profileBannerImg: {
      width: '100%',
      height: 'auto',
      maxHeight: '220px'
    },
    bigUserCardContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid transparent'
    },
    tabs: {
      // borderBottom: '1px solid red'
    },
    popupMenuContainer: {
      background: '#083050',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    popupMenuItem: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0'
    },
    menuItemIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      width: '40px'
    },
    menuItemIcon: {
      fontSize: '20px'
    },
    accordianRightBorder: {
      position: 'absolute',
      width: '1px',
      height: 'calc(100% - 40px)',
      background: '#305C82',
      left: '13px',
      top: '40px'
    },
    linkStyles: {
      display: 'flex',
      alignItems: 'center',
      color: 'inherit',
      ':hover': {
        color: 'inherit'
      }
    },
    selectedLink: {
      color: blue[500],
    },
    drawerFile: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '4px',
      color: groupHeaderTextColor,
      opacity: groupHeaderTextOpacity,
      fontSize: groupHeaderFontSize,
      fontWeight: groupHeaderFontWeight,
      height: '40px'
    },
    drawerFileIcon: {
      fontSize: '32px',
      marginRight: '8px'
    },
    drawerMenuItem: {
      position: 'relative',
      background: tabBackground,
      color: tabTextColor,
      fill: tabTextColor,
      borderLeft: `1px solid ${tabIndicatorBackground}`,
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      // paddingLeft: groupTabIndent,
      paddingLeft: '4px',
      ':hover:not(.activeitem)': {
        background: tabHoverBackground,
        color: tabHoverTextColor,
        fill: tabHoverTextColor,
        borderLeft: `1px solid ${tabIndicatorHoverBackground}`
      }
    },
    drawerMenuItemIcon: {
      height: '24px',
      width: '42px',
      minWidth: '24px',
      marginRight: '8px',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '24px',
      fill: 'inherit'
    },
    drawerMenuItemActive: {
      borderLeft: `1px solid ${tabIndicatorActiveBackground}`,
      color: tabActiveTextColor,
      fill: tabActiveTextColor,
      background: tabActiveBackground
    },
    drawerMenuItemText: {
      width: '100%',
      fontSize: '1rem',
      lineHeight: '14px'
    }
  });

  const handleWindowResize = () => {
    const isMobile = window.innerWidth <= 768;
    toggleDrawer(!isMobile);
    setMobileLayout(isMobile);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const handleOnClickMiniUserCard = () => {
    history.push('/user/profile/about');
    if (isMobileLayout) {
      toggleDrawer(false);
    }
  };

  // let comp = null;
  const activeText = 'User Profile';
  const isUserCardHighlighted =
    pathname.endsWith('/profile') ||
    pathname.endsWith('/profile/about') ||
    pathname.endsWith('/profile/contact') ||
    pathname.endsWith('/profile/practiceaffilication') ||
    pathname.endsWith('/profile/facilityprivileges') ||
    pathname.endsWith('/profile/insurance');

  const providerId = props.provider && props.provider._id
    ? props.provider._id
    : JSON.parse(localStorage.getItem('usr'))._id;

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.splitPanel)}>
        {/* Panel Drawer */}
        <div
          className={css(styles.drawer, isDrawerOpen ? styles.openDrawer : styles.hideDrawer)}
        >
          <div style={{ background: gray[600], height: '32px', color: blue[200], paddingLeft: '4px', paddingTop: '4px', fontSize: '14px', fontWeight: '700' }}>
            My Profile
          </div>
          {/* Drawer tabs */}
          <div className={`p-2 ${css(styles.drawerTabsContainer)}`}>
            {/* Drawer header (Mini user card) */}
            <div
              className={`
              ${isUserCardHighlighted ? 'activeitem' : ''}
              ${css(
                styles.drawerHeader,
                isUserCardHighlighted && styles.drawerHeaderActive
              )}`}
              onClick={handleOnClickMiniUserCard}
            >
              {/* Header icon */}
              <div className={css(styles.drawerHeaderIconContainer)}>
                {props.usr && props.usr.avatarImageUrl
                  ? <img
                    src={props.usr.avatarImageUrl}
                    alt="avatar"
                    style={{
                      width: 'auto',
                      height: '28px',
                      maxHeight: '28px',
                      borderRadius: '4px'
                    }}
                  />
                  : <i className={`fa fa-user ${css(styles.drawerHeaderIcon)}`} />
                }
              </div>
              {/* Header text */}
              <div className={css(styles.drawerHeaderTextContainer)}>
                <div className={css(styles.drawerHeaderText)}>
                  {`${props.usr.displayName ? props.usr.displayName : 'N/A'}`}
                </div>
                <div className={css(styles.drawerHeaderTextSub)}>
                  {`@${props.usr.userName ? props.usr.userName : 'n/a'}`}
                </div>
              </div>
            </div>
            {/* Entity Admin Privileges */}
            <div className={css(styles.drawerAccordian)}>
              <div className={css(styles.drawerFile)}>
                <div>
                  Entity Admin Privileges
                </div>
              </div>
              {/* Practice Affiliations */}
              <div
                className={`noselect ${pathname.endsWith('/practices') ? 'activeitem' : ''} ${css(styles.drawerMenuItem, pathname.endsWith('/practices') && styles.drawerMenuItemActive)}`}
                onClick={() => {
                  history.push('/user/practices');
                  if (isMobileLayout) {
                    toggleDrawer(false);
                  }
                }}
              >
                <Link
                  to='/user/practices'
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                  className={css(styles.linkStyles, pathname.endsWith('/users') && styles.selectedLink)}
                >
                  {/* Icon */}
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" fill="inherit">
                      <path fill="inherit" fillRule="evenodd" d="M17.998 10.127c.688.302 1.31.721 1.858 1.253a6.002 6.002 0 0 1 1.858 4.315V20.1c0 1.338-1.123 2.426-2.5 2.426h-6.818c-.39.887-1.297 1.475-2.299 1.475H2.5C1.12 24 0 22.91 0 21.574v-4.401c0-1.627.658-3.161 1.85-4.318a6.239 6.239 0 0 1 1.858-1.253 5.5 5.5 0 0 1-1.993-1.737A5.234 5.234 0 0 1 .76 6.848c0-2.963 2.483-5.373 5.536-5.373 1.552 0 3.009.623 4.055 1.715A5.39 5.39 0 0 1 12.209.99 5.615 5.615 0 0 1 15.41 0c3.053 0 5.536 2.41 5.536 5.373 0 1.085-.33 2.127-.955 3.02a5.468 5.468 0 0 1-1.993 1.734Zm-2.59-8.229c-.957 0-1.855.361-2.53 1.018a3.389 3.389 0 0 0-1.048 2.456c0 .93.372 1.801 1.049 2.456a3.598 3.598 0 0 0 2.53 1.018c.958 0 1.855-.361 2.53-1.018a3.4 3.4 0 0 0 0-4.912 3.598 3.598 0 0 0-2.53-1.018ZM2.715 6.848c0-.93.372-1.8 1.049-2.455a3.598 3.598 0 0 1 2.53-1.018c.958 0 1.855.36 2.53 1.018a3.398 3.398 0 0 1 0 4.911 3.598 3.598 0 0 1-2.53 1.018c-.955 0-1.856-.36-2.533-1.018A3.401 3.401 0 0 1 2.714 6.85Zm7.76 15.094a.502.502 0 0 0 .159-.37v-4.397a4.116 4.116 0 0 0-1.23-2.929l-.009-.01a4.372 4.372 0 0 0-3.1-1.275c-1.153 0-2.24.438-3.064 1.237a4.118 4.118 0 0 0-1.274 2.974v4.4c0 .29.242.524.54.524h7.597a.544.544 0 0 0 .38-.154Zm-.328-9.596a6.254 6.254 0 0 0-1.267-.745 5.475 5.475 0 0 0 2.472-2.568c.424.44.92.812 1.468 1.093a6.291 6.291 0 0 0-1.859 1.253c-.305.3-.578.622-.814.967Zm9.064 8.277c.297 0 .54-.236.54-.524v-4.404c0-1.12-.452-2.175-1.275-2.973a4.372 4.372 0 0 0-3.064-1.238 4.37 4.37 0 0 0-3.87 2.314 5.913 5.913 0 0 1 1.051 3.372v3.453h6.618Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)}>
                    Practice Affiliations
                  </div>
                </Link>
              </div>
              {/* Facility Privileges */}
              <div
                className={`noselect ${pathname.endsWith('/facilities') ? 'activeitem' : ''} ${css(styles.drawerMenuItem, pathname.endsWith('/facilities') && styles.drawerMenuItemActive)}`}
                onClick={() => {
                  history.push('/user/facilities');
                  if (isMobileLayout) {
                    toggleDrawer(false);
                  }
                }}
              >
                <Link
                  to='/user/facilities'
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                  className={css(styles.linkStyles, pathname.endsWith('/users') && styles.selectedLink)}
                >
                  {/* Icon */}
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="inherit">
                      <path fill="inherit" fillRule="evenodd" d="M0 1a1 1 0 0 1 1-1h13.852a1 1 0 0 1 1 1v22.995H0V1Zm4.533 11.998h6.79v9.998h-6.79v-9.998Zm0-2.753h1.542V7.27h3.708v2.98h1.542V2.822H9.783v2.963H6.075V2.818H4.533v7.427Zm11.826-4.79h6.637a1 1 0 0 1 1 1v17.542H16.36V5.455Zm1.092 2.18h2.182v2.18h-2.182v-2.18Zm5.454 0h-2.182v2.18h2.182v-2.18Zm-2.182 3.276h2.182v2.181h-2.182v-2.181Zm-1.09 0h-2.182v2.181h2.182v-2.181Zm-2.182 3.267h2.182v2.181h-2.182v-2.181Zm5.454 0h-2.182v2.181h2.182v-2.181Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)}>
                    Facility Privileges
                  </div>
                </Link>
              </div>
              {/* Profile Access Manager */}
              <div
                className={`noselect ${pathname.endsWith('/profile-access-manager') ? 'activeitem' : ''} ${css(styles.drawerMenuItem, pathname.endsWith('/profile-access-manager') && styles.drawerMenuItemActive)}`}
                onClick={() => {
                  history.push('/user/profile-access-manager');
                  if (isMobileLayout) {
                    toggleDrawer(false);
                  }
                }}
              >
                <Link
                  to='/user/profile-access-manager'
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                  className={css(styles.linkStyles, pathname.endsWith('/users') && styles.selectedLink)}
                >
                  {/* Icon */}
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" fill="inherit">
                      <path fill="inherit" fillRule="evenodd" d="M15.997 8h-1.143V5.714A5.716 5.716 0 0 0 9.141 0a5.716 5.716 0 0 0-5.713 5.714V8H2.285A2.292 2.292 0 0 0 0 10.286v11.428A2.292 2.292 0 0 0 2.285 24h13.712a2.292 2.292 0 0 0 2.285-2.286V10.286A2.292 2.292 0 0 0 15.997 8ZM9.142 18.286A2.292 2.292 0 0 1 6.857 16a2.292 2.292 0 0 1 2.285-2.286A2.292 2.292 0 0 1 11.428 16a2.292 2.292 0 0 1-2.286 2.286ZM5.712 5.764v2.24h6.856v-2.24c0-1.916-1.537-3.474-3.428-3.474-1.89 0-3.428 1.558-3.428 3.474Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)}>
                    Profile Access Manager
                  </div>
                </Link>
              </div>
            </div>
            {/* Provider Tabs */}
            <div className={css(styles.drawerAccordian)}>
              {/* Case Ledger */}
              <div
                className={`noselect ${pathname.endsWith('/revenue') ? 'activeitem' : ''} ${css(styles.drawerMenuItem, pathname.endsWith('/revenue') && styles.drawerMenuItemActive)}`}
                onClick={() => {
                  history.push('/user/revenue');
                  if (isMobileLayout) {
                    toggleDrawer(false);
                  }
                }}
              >
                <Link
                  to='/user/revenue'
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                  className={css(styles.linkStyles, pathname.endsWith('/users') && styles.selectedLink)}
                >
                  {/* Icon */}
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="inherit"
                    >
                      <path
                        fill="inherit"
                        fillRule="evenodd"
                        d="M16.8 5.053h4.8c1.332 0 2.4 1.124 2.4 2.526v13.895C24 22.876 22.932 24 21.6 24H2.4C1.068 24 0 22.876 0 21.474L.012 7.579c0-1.402 1.056-2.526 2.388-2.526h4.8V2.526C7.2 1.124 8.268 0 9.6 0h4.8c1.332 0 2.4 1.124 2.4 2.526v2.527Zm-7.2-.001h4.8V2.525H9.6v2.527Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)}>
                    Case Ledger
                  </div>
                </Link>
              </div>
              {/* Payments Ledger */}
              <div
                className={`noselect ${pathname.endsWith('/payments') ? 'activeitem' : ''} ${css(styles.drawerMenuItem, pathname.endsWith('/payments') && styles.drawerMenuItemActive)}`}
                onClick={() => {
                  history.push('/user/payments');
                  if (isMobileLayout) {
                    toggleDrawer(false);
                  }
                }}
              >
                <Link
                  to='/user/payments'
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                  className={css(styles.linkStyles, pathname.endsWith('/users') && styles.selectedLink)}
                >
                  {/* Icon */}
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="inherit">
                      <path fill="inherit" fillRule="evenodd" d="M23.157 3a.843.843 0 0 0-.844.844v2.015A12.007 12.007 0 0 0 18.633 2 11.94 11.94 0 0 0 12.001 0a11.955 11.955 0 0 0-8.18 3.22 11.958 11.958 0 0 0-3.787 7.873.844.844 0 0 0 .778.904C.833 12 .854 12 .875 12a.845.845 0 0 0 .842-.78A10.278 10.278 0 0 1 4.97 4.454 10.28 10.28 0 0 1 12 1.687c2.04 0 4.01.593 5.7 1.718a10.303 10.303 0 0 1 3.488 3.907h-2.344a.843.843 0 1 0 0 1.688h4.313A.843.843 0 0 0 24 8.156V3.844A.843.843 0 0 0 23.157 3Zm.029 9.002a.845.845 0 0 0-.905.778 10.278 10.278 0 0 1-3.253 6.764A10.27 10.27 0 0 1 12 22.312a10.25 10.25 0 0 1-5.7-1.718 10.303 10.303 0 0 1-3.488-3.907h2.344a.843.843 0 1 0 0-1.688H.844a.843.843 0 0 0-.844.844v4.313a.843.843 0 1 0 1.687 0V18.14A12.025 12.025 0 0 0 5.365 22c1.968 1.308 4.26 2 6.635 2 3.046 0 5.953-1.145 8.179-3.221a11.944 11.944 0 0 0 3.785-7.872.843.843 0 0 0-.778-.905ZM10.653 9.833c0 .633.487 1.04 2 1.433 1.513.394 3.133 1.04 3.133 2.934 0 1.366-1.033 2.12-2.333 2.366V18h-2v-1.446c-1.28-.274-2.373-1.094-2.453-2.554h1.466c.074.787.614 1.4 1.987 1.4 1.473 0 1.8-.733 1.8-1.193 0-.62-.334-1.207-2-1.606-1.86-.447-3.133-1.214-3.133-2.754 0-1.286 1.04-2.126 2.333-2.406V6h2v1.46c1.393.34 2.093 1.393 2.14 2.54H14.12c-.04-.834-.48-1.4-1.667-1.4-1.127 0-1.8.506-1.8 1.233Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)}>
                    Payments Ledger
                  </div>
                </Link>
              </div>
              {/* Credentialing */}
              <div
                className={`noselect ${pathname.endsWith('/credentialing') ? 'activeitem' : ''} ${css(styles.drawerMenuItem, pathname.endsWith('/credentialing') && styles.drawerMenuItemActive)}`}
                onClick={() => {
                  history.push('/user/credentialing');
                  if (isMobileLayout) {
                    toggleDrawer(false);
                  }
                }}
              >
                <Link
                  to='/user/credentialing'
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                  className={css(styles.linkStyles, pathname.endsWith('/users') && styles.selectedLink)}
                >
                  {/* Icon */}
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" fill="inherit">
                      <path fill="inherit" d="M24 11.444 21.338 8.4l.371-4.025-3.938-.895L15.709 0 12 1.593 8.29 0 6.23 3.48l-3.94.884.372 4.036L0 11.444l2.662 3.043-.371 4.037 3.938.894 2.062 3.491L12 21.305l3.71 1.593 2.06-3.48 3.94-.894-.372-4.026L24 11.444Zm-4.31 1.614-.61.71.087.926.197 2.128-2.99.676-.48.807-1.08 1.833-1.941-.84-.873-.37-.862.37-1.942.84-1.08-1.822-.48-.807-2.989-.676.197-2.138.087-.928-.611-.709-1.407-1.604L4.32 9.84l.61-.71-.097-.937-.197-2.117 2.99-.676.48-.807 1.08-1.833 1.941.84.873.37.862-.37 1.942-.84 1.08 1.833.48.807 2.989.676-.197 2.128-.087.927.611.709 1.407 1.604-1.396 1.614Z" /><path fill="#96C8FF" d="m9.916 13.364-2.53-2.542-1.615 1.625 4.145 4.157 8.008-8.03-1.615-1.625-6.393 6.415Z" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)}>
                    Credentialing
                  </div>
                </Link>
              </div>
              {/* Insurance */}
              <div
                className={`noselect ${pathname.endsWith('/insurance') ? 'activeitem' : ''} ${css(styles.drawerMenuItem, pathname.endsWith('/insurance') && styles.drawerMenuItemActive)}`}
                onClick={() => {
                  history.push('/user/insurance');
                  if (isMobileLayout) {
                    toggleDrawer(false);
                  }
                }}
              >
                <Link
                  to='/user/insurance'
                  onClick={() => {
                    if (isMobileLayout) {
                      toggleDrawer(false);
                    }
                  }}
                  className={css(styles.linkStyles, pathname.endsWith('/users') && styles.selectedLink)}
                >
                  {/* Icon */}
                  <div className={css(styles.drawerMenuItemIcon)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" fill="inherit">
                      <path fill="inherit" fillRule="evenodd" d="M4 0a4 4 0 0 0-4 4v20.8a4 4 0 0 0 4 4h20.8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Zm.202 5.829L14.488 2.4l10.286 3.429v10.285c0 5.681-4.605 10.286-10.286 10.286-5.681 0-10.286-4.604-10.286-10.286V5.83Zm18.644 10.283a8.357 8.357 0 0 1-16.715 0V7.273l8.357-2.946 8.358 2.946v8.84Zm-9.793-3.88c0 .633.487 1.04 2 1.433 1.514.393 3.133 1.04 3.133 2.933 0 1.367-1.033 2.12-2.333 2.367v1.433h-2v-1.446c-1.28-.274-2.373-1.094-2.453-2.554h1.466c.074.787.614 1.4 1.987 1.4 1.473 0 1.8-.733 1.8-1.193 0-.62-.333-1.207-2-1.607-1.86-.446-3.133-1.213-3.133-2.753 0-1.287 1.04-2.127 2.333-2.407v-1.44h2v1.46c1.394.34 2.094 1.394 2.14 2.54H16.52c-.04-.833-.48-1.4-1.667-1.4-1.127 0-1.8.507-1.8 1.234Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className={css(styles.drawerMenuItemText)}>
                    Insurance
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* Panel details */}
        <div
          className={css(styles.detail)}
          style={{
            width: isDrawerOpen ? `calc(100vw - ${DRAWER_WIDTH}px)` : '100vw'
          }}
        >
          <div className={css(styles.detailHeader)}>
            <div
              onClick={() => toggleDrawer(!isDrawerOpen)}
            >
              <i
                className={`mr-2 fa ${isDrawerOpen ? 'fa-chevron-circle-left' : 'fa-chevron-circle-right'}`}
                style={{ fontSize: '24px' }}
              />
            </div>
            <div style={{ minWidht: '150px' }}>
              {activeText}
            </div>
          </div>
          {/* Active Tab */}
          <div className='p-2' style={{ height: 'calc(100% - 40px)' }}>
            <Switch>
              <Route exact path={path}>
                <AboutUser
                  userData={props.usr}
                  reloadUserData={(usr) => {
                    console.log('Reload user data ...');
                    console.log(usr);
                    props.reloadData(usr);
                  }}
                />
              </Route>
              <Route path={`${path}/profile`}>
                <AboutUser
                  userData={props.usr}
                  reloadUserData={(usr) => {
                    console.log('Reload user data ...');
                    console.log(usr);
                    props.reloadData(usr);
                  }}
                />
              </Route>
              <Route path={`${path}/scheduling`}>
                <Placeholder text='Placeholder for Scheduling' />
              </Route>
              <Route path={`${path}/revenue`}>
                {/* <Placeholder text='Placeholder for Revenue Cycle' /> */}
                <RevenueCycleManagement />
              </Route>
              <Route path={`${path}/credentialing`}>
                <Placeholder text='Placeholder for Credentialing' />
              </Route>
              <Route path={`${path}/practices`}>
                <ProviderPracticeGrid createBookmark />
              </Route>
              <Route path={`${path}/facilities`}>
                <ProviderFacilitiesGrid userId={providerId} />
              </Route>
              <Route path={`${path}/companies`}>
                <ProviderCompanies />
              </Route>
              <Route path={`${path}/payments`}>
                <h1>Payment Ledger placeholder</h1>
              </Route>
              <Route path={`${path}/insurance`}>
                <h1>Insurance placeholder</h1>
              </Route>
              <Route path={`${path}/profile-access-manager`}>
                <ProfileAccessManager premissionMode={6} />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps({ user }) {
  return { ...user };
}

export default connect(mapStateToProps, { reloadData })(UserProfile);
